<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': visible}">
  <div class="modal-dialog" role="document" [ngClass]="modalSize">
    <div class="modal-content">
      <div class="padding-close d-flex justify-content-end">
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="padding-content overflow">
        @if (showHeader) {
          <div class="modal-header">
            <div modalTitle>
              <ng-content select="[modalTitle]"></ng-content>
            </div>
          </div>
        }
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
        @if (showFooter) {
          <div class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
          </div>
        }
      </div>
    </div>
    </div>
</div>
